// extracted by mini-css-extract-plugin
export default {"loaderBlock":"Loader_loaderBlock__ngweN","mark":"Loader_mark__kAMWC","glow":"Loader_glow__0GxAv","base":"Loader_base__5M1dc","fill":"Loader_fill__ZNGuA"};